// extracted by mini-css-extract-plugin
module.exports = {"card":"FormCard_card__mcmuj","title":"FormCard_title__34KgM","header":"FormCard_header__mYxJI","subtitle":"FormCard_subtitle__MLB7K"};